export const CLUSTER_SIZE      = 16;  // Smallest cluster radius in px
export const CLUSTER_SIZE_STEP =  4;  // Cluster growth in px for each size level
